import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const NAV_LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  return (
    <header className="navbar">
      <nav className="navbar__inner" aria-label="Main navigation">
        <a href="#top" className="navbar__logo">
          AB<span className="gradient-text">·17</span>
        </a>
        <div className="navbar__links">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="navbar__link">
              {link.label}
            </a>
          ))}
          <Link to="/spider" className="navbar__icon-button" aria-label="Open spider mode">
            <span className="navbar__icon" aria-hidden="true">🕷</span>
          </Link>
          <a href="/tokenizer" className="navbar__pill">
            Tokenizer
          </a>
        </div>
      </nav>
    </header>
  );
}
